// ------------------ accordion ------------------ //
$(".product--accordion-question").on("click", function () {
  // Close other accordions when opening new one
  if (!$(this).hasClass("open")) {
    $(".product--accordion-question.open").click();
  }
  // Save the sibling of the toggle we clicked on
  let sibling = $(this).siblings(".product--accordion-response");
  let animationDuration = 500;

  if ($(this).hasClass("open")) {
    // Close the content div if already open
    sibling.animate({ height: "0px" }, animationDuration);
  } else {
    // Open the content div if already closed
    sibling.css("height", "auto");
    let autoHeight = sibling.height();
    sibling.css("height", "0px");
    sibling.animate({ height: autoHeight }, animationDuration, () => {
      sibling.css("height", "auto");

      // Scroll the page to the accordion, leaving 200 pixels from the top
    });
  }
  // Open and close the toggle div
  $(this).toggleClass("open");
});

// ----------------------- colors ------------------------ //

window.addEventListener("DOMContentLoaded", (event) => {
  // Get the content of the elements
  const textColor2 = document.querySelector(".textcolor2").textContent.trim();
  const backgroundColor2 = document
    .querySelector(".backgroundcolor2")
    .textContent.trim();

  // Generate the dynamic styles
  const styles = `
        .navbar, .product--hero-content {
            color: ${textColor2};
        }

        .product-background {
            background-color: ${backgroundColor2};
        }

        .is--btn {
            color: ${textColor2} !important;
            border-color: ${textColor2} !important;
        }

        .quantity--field {
            color: ${backgroundColor2};
            background-color: ${textColor2};
        }
    `;

  // Apply the styles to the <style> element
  document.getElementById("dynamic-styles-prods").textContent = styles;
});

// ------------------ hide accordions when not used ------------------ //

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".flex--20").forEach((flexContainer) => {
    let hasVisibleAccordion = false;

    flexContainer
      .querySelectorAll(".product--accordion")
      .forEach((accordion) => {
        let richText = accordion.querySelector(".richtext-2.w-richtext");

        if (richText && richText.innerHTML.trim() === "") {
          accordion.style.display = "none";
        } else {
          hasVisibleAccordion = true; // At least one visible accordion
        }
      });

    // If no .product--accordion is visible, hide the parent .flex--20
    if (!hasVisibleAccordion) {
      flexContainer.style.display = "none";
    }
  });
});
